import Vue from 'vue'
import Endpoints from '@/share/Endpoints'

const buildListUrl = (memberId, query = {}) => {
  const base = Endpoints.adminMemberSubmembers.replace(':memberId', memberId)
  const params = new URLSearchParams()
  if (query.page) params.append('page', query.page)
  if (query.name) params.append('name', query.name)
  if (query.validationStatus) params.append('validationStatus', query.validationStatus)
  if (query.branch) params.append('branch', query.branch)
  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}

export const fetchAdminSubmembers = async ({ commit }, { memberId, query = {} }) => {
  if (!memberId) {
    return { status: false, message: 'Falta el identificador del miembro' }
  }
  commit('setLoading', true)
  commit('setError', null)
  try {
    const response = await Vue.axios({
      method: 'GET',
      url: buildListUrl(memberId, query),
    })
    const data = response?.data || {}
    commit('setSubmembers', data)
    return { status: true, data }
  } catch (error) {
    const message =
      error?.response?.data?.error?.message ||
      error?.message ||
      'No fue posible obtener los submiembros'
    commit('setError', message)
    return { status: false, message }
  } finally {
    commit('setLoading', false)
  }
}

export const createAdminSubmember = async (
  { commit },
  { memberId, user, customFields = {}, headOffice = null, branch = null },
) => {
  if (!memberId) return { status: false, message: 'Falta el identificador del miembro' }
  try {
    const response = await Vue.axios({
      method: 'POST',
      url: Endpoints.adminMemberSubmembers.replace(':memberId', memberId),
      data: { user, customFields, headOffice, branch },
    })
    const created = response?.data?.user || null
    if (created) commit('upsertSubmember', created)
    return { status: true, user: created }
  } catch (error) {
    const message =
      error?.response?.data?.error?.message ||
      error?.message ||
      'No fue posible crear el submiembro'
    return { status: false, message }
  }
}

export const updateAdminSubmember = async (
  { commit },
  { memberId, submemberId, user },
) => {
  if (!memberId || !submemberId) {
    return { status: false, message: 'Faltan identificadores' }
  }
  try {
    const url = Endpoints.adminMemberSubmember
      .replace(':memberId', memberId)
      .replace(':submemberId', submemberId)
    const response = await Vue.axios({ method: 'PUT', url, data: { user } })
    const updated = response?.data?.user || null
    if (updated) commit('upsertSubmember', updated)
    return { status: true, user: updated }
  } catch (error) {
    const message =
      error?.response?.data?.error?.message ||
      error?.message ||
      'No fue posible actualizar el submiembro'
    return { status: false, message }
  }
}

export const clearAdminSubmembers = ({ commit }) => {
  commit('clearSubmembers')
}
